interface NullViewerProps {
  value: null | undefined;
}

export function NullViewer({}: NullViewerProps) {
  return <span className='text-neutral-400 italic text-sm'>—</span>;
}
